import { render } from "./GroupRecursiveTicketNotification.vue?vue&type=template&id=cc353bea"
import script from "./GroupRecursiveTicketNotification.vue?vue&type=script&lang=js"
export * from "./GroupRecursiveTicketNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__